rdefine('app/products/properties/Pdf',['backbone','text!products/prop/pdf.html'],function(Backbone,template) {
    return Backbone.Ribs.View.extend({
        bindings:{
            '.fileinput-filename':{
                text: {
                    data: '',
                    processor: function (a) {
                        return a ? a.name : '';
                    }
                }
            },
            '.fileinput-anew':{
                toggle:{
                    data:'',
                    processor: function(a) {
                        return !(a && a.name && a.name.length > 0);
                    }
                }
            },
            '.fileinput-aexists': {
                toggle:{
                    data:'',
                    processor: function(a) {
                        return (a && a.name && a.name.length > 0);
                    }
                }
            },
            '.fileinput':{
                classes:{
                    'fileinput-exists':{
                        data:'',
                        processor: function(a) {
                            return (a && a.name && a.name.length > 0);
                        }
                    }
                }
            }
        },
        events:{
            'change.bs.fileinput .fileinput':'onChange',
            'clear.bs.fileinput .fileinput':'onClear'
        },
        initialize:function(options) {
            this.preventBindings();
            this.field = 'property_' + this.model.get("id");
            this.cform = options.cform;

            this.bindings['.fileinput-filename'].text.data='cform.' + this.field;
            this.bindings['.fileinput-anew'].toggle.data='cform.' + this.field;
            this.bindings['.fileinput-aexists'].toggle.data='cform.' + this.field;
            this.bindings['.fileinput'].classes['fileinput-exists'].data='cform.property_' + this.model.get("id");

            var key = "prop_pdf_"+options.lmodel.get("language")+"_"+options.lmodel.collection.ndx+"_"+this.model.get("id")
            this.$el.html(Template7.compile(template)());
            this.$el.find("input").attr('name',key);
            this.applyBindings();
        },
        onChange:function() {
            this.cform.set(this.field,{name:this.$el.find('.fileinput-filename').text()});
        },
        onClear: function() {
            this.cform.set(this.field,{name:'',deleted:true});
        }
    });
});